module.exports = __webpack_public_path__ + "src/assets/img/2-chevron-w.92d773d0.svg";